import gql from 'graphql-tag'

export default gql`query ycmdFacilitySearch($facility_id: ID, $limit: Int, $page: Int, $search: String, $location: String, $group_ids: [ID]) {
	ycmdFacilitySearch(facility_id: $facility_id, limit: $limit, page: $page, search: $search, location: $location, group_ids: $group_ids)
    {
		name
		id
		shortcode
		units {
			unit_id
			name
			number
			shortcode
			new_patients
    		default_patient_status
		}
    }
}`
